var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"F404PageBox"},[_c('div',{staticClass:"font"},[_vm._v("404")]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)+"Page开发中~~~~敬请期待！")])])}
var staticRenderFns = []

export { render, staticRenderFns }